<template>
  <Index/>
</template>
<script>
import { mapState } from 'vuex'
import Index from './Index'
export default {
  components: {
    Index
  },
  computed: {
    ...mapState('app', ['idioma', 'strings', 'user', 'empresa', 'acesso'])
  },

  created () {
    localStorage.setItem('idioma', 0)
    /*
    if (this.user === null) window.location.href = '/site'
    else window.location.href = '/dashboard'
    */
  }
}
</script>
